export default __webpack_public_path__ + "fonts/brand-icons.svg";